import { createSlice } from "@reduxjs/toolkit";
import { userLogin, loginedUser, userRegister } from "./../actions/authAction";

const INIT_STATE = {
  isLoading: false,
  user: {},
  users: [],
  authUserPermissions: [],
  userPermissions: [],
  isError: false,
  error: "",
  isCheckingAuth: true,
  isAuthonticated: false,
  token: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState: INIT_STATE,
  reducers: {
    logout: (state) => {
      state.isLoading = false;
      state.isError = false;
      state.error = "";
      state.isAuthonticated = false;
      state.token = null;
      localStorage.removeItem("cardsToken");
      window.location.href = "/user/login";
    },
  },
  extraReducers: (builder) => {
    // userRegister
    builder
      .addCase(userRegister.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
        state.isAuthonticated = false;
        state.token = null;
      })
      .addCase(userRegister.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.error = "";
        state.isAuthonticated = true;
        state.users = [...state.users, action.payload];
      })
      .addCase(userRegister.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
        state.isAuthonticated = false;
        state.token = null;
      });

    // userLogin
    builder
      .addCase(userLogin.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
        state.error = "";
        state.isAuthonticated = false;
        state.token = null;
      })
      .addCase(userLogin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.error = "";
        state.isAuthonticated = true;
        state.user = action.payload.user;
        state.token = action.payload.token;
      })
      .addCase(userLogin.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
        state.isAuthonticated = false;
        state.token = null;
      });

    // loginedUser
    builder
      .addCase(loginedUser.pending, (state) => {
        state.isCheckingAuth = true;
      })
      .addCase(loginedUser.fulfilled, (state, action) => {
        state.isCheckingAuth = false;
        state.isAuthonticated = true;
        state.user = action.payload.user;
        state.token = JSON.parse(localStorage.getItem("cardsToken"));
      })
      .addCase(loginedUser.rejected, (state) => {
        state.isCheckingAuth = false;
        state.isAuthonticated = false;
        state.user = {};
        state.token = null;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;
